// import pic from '../assets/image/rectangle.png'
import pic from "../assets/image/okx2.png"

function Socialize() {
  return (
    <div className='pl-4 pb-4 md:pl-8 lg:pl-16'>
    <img src={pic} alt="" />
    </div>
  )
}

export default Socialize